import ImmediateTasks from '@/common/containers/Forms/ImmediateTasks/ImmediateTasks';

export default ImmediateTasks;
